export default __webpack_public_path__ + "static/intro-team-1-2059553f6a6696c7968e481158c11639.jpg";